import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import PushNotification from '../PushNotification';

const useStyles = theme => ({
    root: {
      flexGrow: 1,
      width: '100%',
    },
      appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: '2rem',
      flex: 1,
      color: 'white'
    },
    paper: {
      padding: '2rem',
      textAlign: 'center',
    },
    checkedIcon:{
        width: 16,
        height: 16,
    },
    option:{
          fontWeight: 600,
        fontSize:'0.75rem',
    },
    typography:{
        fontSize: '0.75rem'
    },
    select:{
        marginTop: '0',
        marginRight:'12px',
        padding: '0'
    },
    menu:{
        fontSize: '0.75rem'
    }
  });
  
function Mobile(props) {
    const [mobile_data, setMobileData] = useState({})
	useEffect(()=>{
        setMobileData(props.mobile_data)
    },[props])
	return (
		<React.Fragment>
            <TextField
                id="created_at"
                value={mobile_data.created_at}
                disabled
                type="datetime-local"
                name="created_at"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                    shrink: true
                }}
                inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                InputProps={{
                    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha solicitud</Typography></InputAdornment>,
                }}
            />	
            <TextField
                id="comments"
                value={mobile_data.comments}
                disabled
                fullWidth
                type="text"
                name="comments"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                    shrink: true
                }}
                inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                InputProps={{
                    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Comentarios</Typography></InputAdornment>,
                }}
            />	
            <TextField
                id="use_same_provider"
                value={(mobile_data.use_same_provider) ? 'Si' : (!mobile_data.use_same_provider) ? 'No' : 'Sin definir'}
                disabled
                type="text"
                name="use_same_provider"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                    shrink: true
                }}
                inputProps={{style:{fontSize: '0.75rem'}}}
                InputProps={{
                    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Usar mismo proveedor</Typography></InputAdornment>,
                }}
            />	

            <TextField
                id="desired_zone"
                value={mobile_data.desired_zone_desc}
                disabled
                fullWidth
                type="text"
                name="desired_zone"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                    shrink: true
                }}
                inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                InputProps={{
                    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Zona deseada</Typography></InputAdornment>,
                }}
            />	
            {mobile_data.desired_shift_dates && mobile_data.desired_shift_dates.map((val,idx)=>{

                return (
                    <TextField
                        id={"desired_shift_date_" + idx}
                        value={val.date || ''}
                        disabled
                        key={"desired_shift_date_" + idx}
                        name={"desired_shift_date_" + idx}
                        margin="normal"
                        className="m-0 p-0 mr-2"
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha deseada {idx + 1}</Typography></InputAdornment>,
                        }}
                    />	

                )

            })}
            {
                (mobile_data.ready_to_deliver) ? <TextField
                        id="delivered_at"
                        value={mobile_data.delivered_at}
                        disabled
                        type="datetime-local"
                        key="delivered_at"
                        name="delivered_at"
                        margin="normal"
                        className="m-0 p-0 mr-2"
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha entrada taller</Typography></InputAdornment>,
                        }}
                    />	
                    :
                    ''
            }
            {
                (mobile_data.ready_to_pickup) ? <TextField
                        id="pickedup_at"
                        value={mobile_data.pickedup_at}
                        disabled
                        type="date"
                        key="pickedup_at"
                        name="pickedup_at"
                        margin="normal"
                        className="m-0 p-0 mr-2"
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha retiro taller</Typography></InputAdornment>,
                        }}
                    />	
                    :   
                        ''
            }
            {mobile_data.user_id && 
                <>
                    <div class="row">
                        <div class="col-12">
                            <Typography variant='body1'>Enviar notificación</Typography>
                        </div>
                    </div>
                    <PushNotification user_id={mobile_data.user_id} onRefresh={() => console.log('')}/>
                </>
            }

		</React.Fragment>
	)

}

export default withStyles(useStyles)(Mobile);
